<template>
  <div>
    <header id="header-out">
      <h1><span>Waple</span></h1>
    </header>
    <section id="wrap">
      <div class="customer-page">
        <div class="exptn">
          고객 인증 및 정보 입력페이지가<br />만료되었습니다.
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>